module.exports = __webpack_public_path__ + "img/pm.67e11100.svg";